import { render, staticRenderFns } from "./CommitteeAddScore.vue?vue&type=template&id=115c86f2&scoped=true"
import script from "./CommitteeAddScore.vue?vue&type=script&lang=js"
export * from "./CommitteeAddScore.vue?vue&type=script&lang=js"
import style0 from "./CommitteeAddScore.vue?vue&type=style&index=0&id=115c86f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c86f2",
  null
  
)

export default component.exports